<template>
  <div class="h-100 d-flex align-items-center bg-dark">
    <page-header remove-back-button close-button background="bg-dark" @back="closePage('Close')" />
    <div class="max-width container-fluid mb-5 pt-4">
      <service-list
        :title="trans('services.servicelist_page.title')"
        :description="trans('services.servicelist_page.description')"
        textColor="text-white"
        textAlign="text-center"
        mount-location="Introduction"
        @serviceListCount="serviceListCount = $event"
      />
      <div v-if="serviceListCount === 0" class="text-white text-center">
        <b-img src="/images/service-list/empty-list.svg" />
        <h6 class="mt-4 mb-1">{{ trans("services.servicelist_page.title_empty_list") }}</h6>
        <p>{{ trans("services.servicelist_page.description_empty_list") }}</p>
      </div>
      <div class="w-100 text-center mt-3">
        <b-button variant="outline-secondary" @click="closePage('DoItLater')">
          {{ ctaLabel }}
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from "../organisms/PageHeader";
import ServiceList from "../organisms/ServiceList";

export default {
  name: "ServiceListPage",
  components: { PageHeader, ServiceList },
  data() {
    return {
      serviceListCount: null,
    };
  },
  computed: {
    ctaLabel: function () {
      return this.serviceListCount === 0
        ? this.trans("services.servicelist_page.button_homepage")
        : this.trans("services.servicelist_page.button_later");
    },
  },
  methods: {
    closePage(eventSuffix) {
      trackEvent(`ServiceList${eventSuffix}`, { location: "Introduction" });
      this.redirectToHome();
    },
    redirectToHome() {
      this.$router.push({ name: "servicedashboard" }).catch(() => {});
    },
  },
};
</script>

<style scoped lang="scss"></style>
